import Cookies from 'universal-cookie';
const cookies = new Cookies();

export function checkFeatureFlag(feature) {
  const featuresCookie = cookies.get('featureFlags');

  return featuresCookie && featuresCookie.split('|').includes(feature);
}
